// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"7d853cba","815":"fb98fb0a","978":"90965b33"}[chunkId] + ".chunk.js";
};